/* src/pages/ManagedITServices.js */

import React from "react";
import PageSection from "../components/PageSection";
import { Helmet } from "react-helmet";
import styles from "./Pages.module.css"; // CSS Module
import managedITServicesImage from "../assets/Images/managed-it-services.jpg";

function ManagedITServices() {
  const faqs = [
    {
      question: "What do you actually do?",
      answer:
        "I keep an eye on your systems, handle updates, fix problems before they become emergencies, and make sure your backups are working. Think of it as having an IT person on call without paying someone full-time.",
    },
    {
      question: "Why would I need this?",
      answer:
        "If you don't have time to deal with IT stuff or you're tired of only calling someone when things break, this makes sense. I watch your systems proactively so small problems get fixed before they turn into big expensive ones.",
    },
    {
      question: "Do I have to sign a long contract?",
      answer:
        "Nope. I offer flexible month-to-month options. If it's not working out, you're not locked in.",
    },
  ];

  return (
    <PageSection title="Managed IT Services" cta faqs={faqs}>
      <Helmet>
        <title>Managed IT Services | Tharpe Industries</title>
        <meta
          name="description"
          content="Comprehensive management of your IT infrastructure, allowing you to focus on your core business. Proactive IT solutions to ensure seamless operations."
        />
      </Helmet>
      <div className={styles.contentContainer}>
        <img
          src={managedITServicesImage}
          alt="Managed IT Services"
          className={styles.pageImage}
          loading="lazy"
        />
        <div className={styles.textContent}>
          <p>
            Tired of only calling IT when something breaks? With managed IT services, I keep an eye on your systems 
            and fix small problems before they become big expensive emergencies. No more surprise downtime or 
            scrambling to find help when your network goes down.
          </p>
          <p>
            I handle updates, monitor your systems, manage backups, and provide ongoing support - basically everything 
            you'd want an in-house IT person to do, but without the full-time salary. It's like having me on call 
            for a flat monthly rate.
          </p>
        </div>
      </div>
    </PageSection>
  );
}

export default ManagedITServices;
